import { makeStyles } from '@material-ui/core/styles';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import clsx from 'clsx';
import React from 'react';
import ChipColored from '@sprinx/react-mui-components/ChipColored';
import { CatalogueProduct } from '../../../api/products/catalogue';
import ProductDetailLink from '../../../components/ProductDetailLink';
import useProductUrl from '../../../hooks/useProductUrl';
import useTranslateWithFallback from '../../../hooks/useTranslateWithFallback';
import { isProductCanceled } from '../../../helpers/isProductCanceled';
import ProductDetailCanceledStatus from '../../../components/ProductDetailCanceledStatus';

export interface CataloguePageListContentItemRowNameProps
  extends StandardDivProps<CataloguePageListContentItemRowNameClassKey> {
  product: CatalogueProduct;
}

export type CataloguePageListContentItemRowNameClassKey = 'root' | 'outletChipWrapper';

const themeSettings = { name: 'CataloguePageListContentItemRowName' };
const useStyles = makeStyles(
  (theme) => ({
    root: {
      ...theme.typography.h6,
      fontSize: '1.1rem',
      fontWeight: theme.typography.fontWeightMedium,
      paddingBottom: theme.spacing(1),
      // borderBottom: `1px solid ${theme.palette.divider}`,
      marginBottom: theme.spacing(1),
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5),

      '& > a': {
        color: theme.palette.text.primary,
        whiteSpace: 'break-spaces',
        maxWidth: 'calc(100% - 290px)',
      },
    },
    crossedText: {
      textDecoration: 'line-through',
    },
    highlight: {
      color: theme.palette.error.main,
    },
    outletChipWrapper: {
      marginRight: theme.spacing(1),
      '& .MuiChip-label': {
        color: `${theme.palette.common.white} !important`,
        fontWeight: 600,
      },
    },
  }),
  themeSettings,
);

const CataloguePageListContentItemRowName = React.forwardRef<HTMLDivElement, CataloguePageListContentItemRowNameProps>(
  ({ className, classes: pClasses, product, ...rest }, ref) => {
    const t = useTranslateWithFallback();
    const classes = useStyles({ classes: pClasses });
    const to = useProductUrl(product);

    const productIsCanceled = isProductCanceled(product.taxonomies);

    return (
      <div ref={ref} className={clsx(classes.root, className)} {...rest}>
        {product.taxonomies?.includes('/catalogue/outlet') && (
          <ChipColored label='OUTLET' color='#FFA800' size='small' className={classes.outletChipWrapper} />
        )}
        <ProductDetailLink
          className={clsx({
            [classes.crossedText]: productIsCanceled,
          })}
          to={to}
          variant='inherit'
          noWrap
        >
          {t(product.displayName || product.name, { acceptString: true })}
        </ProductDetailLink>
        {productIsCanceled && <ProductDetailCanceledStatus />}
      </div>
    );
  },
);

CataloguePageListContentItemRowName.displayName = 'CataloguePageListContentItemRowName';

export default withThemeProps(themeSettings)(CataloguePageListContentItemRowName);
